import type { Class } from "@/types";
import { CHARACTER_CLASSES } from "@/constants";

export const thief: Class = {
  name: "Thief",
  id: CHARACTER_CLASSES.THIEF,
  classType: CHARACTER_CLASSES.THIEF,
  description:
    'Thieves are those who take what they want or need by stealth, disarming traps and picking locks to get to the gold they crave; or "borrowing" money from pockets, beltpouches, etc. right under the nose of the "mark" without the victim ever knowing.',
  hitDie: "1d4",
  primaryAttribute: "dexterity",
  abilityRequirements: [
    {
      ability: "dexterity",
      min: 9,
    },
  ],
  allowedWeapons: [],
  allowedArmor: ["leather"],
  specialAbilities: [
    {
      name: "Sneak Attack",
      description:
        "Thieves can perform a Sneak Attack any time they are behind an opponent in melee and it is likely the opponent doesn't know the Thief is there. The Sneak Attack is made with a +4 attack bonus and does double damage if it is successful.",
    },
  ],
  experienceTable: {
    1: 0,
    2: 1250,
    3: 2500,
    4: 5000,
    5: 10000,
    6: 20000,
    7: 40000,
    8: 75000,
    9: 150000,
    10: 225000,
    11: 300000,
    12: 375000,
    13: 450000,
    14: 525000,
    15: 600000,
    16: 675000,
    17: 750000,
    18: 825000,
    19: 900000,
    20: 975000,
  },
  skills: {
    1: {
      openLocks: 25,
      removeTraps: 20,
      pickPockets: 30,
      moveSilently: 25,
      climbWalls: 80,
      hide: 10,
      listen: 30,
    },
    2: {
      openLocks: 30,
      removeTraps: 25,
      pickPockets: 35,
      moveSilently: 30,
      climbWalls: 81,
      hide: 15,
      listen: 34,
    },
    3: {
      openLocks: 35,
      removeTraps: 30,
      pickPockets: 40,
      moveSilently: 35,
      climbWalls: 82,
      hide: 20,
      listen: 38,
    },
    4: {
      openLocks: 40,
      removeTraps: 35,
      pickPockets: 45,
      moveSilently: 40,
      climbWalls: 83,
      hide: 25,
      listen: 42,
    },
    5: {
      openLocks: 45,
      removeTraps: 40,
      pickPockets: 50,
      moveSilently: 45,
      climbWalls: 84,
      hide: 30,
      listen: 46,
    },
    6: {
      openLocks: 50,
      removeTraps: 45,
      pickPockets: 55,
      moveSilently: 50,
      climbWalls: 85,
      hide: 35,
      listen: 50,
    },
    7: {
      openLocks: 55,
      removeTraps: 50,
      pickPockets: 60,
      moveSilently: 55,
      climbWalls: 86,
      hide: 40,
      listen: 54,
    },
    8: {
      openLocks: 60,
      removeTraps: 55,
      pickPockets: 65,
      moveSilently: 60,
      climbWalls: 87,
      hide: 45,
      listen: 58,
    },
    9: {
      openLocks: 65,
      removeTraps: 60,
      pickPockets: 70,
      moveSilently: 65,
      climbWalls: 88,
      hide: 50,
      listen: 62,
    },
    10: {
      openLocks: 68,
      removeTraps: 63,
      pickPockets: 74,
      moveSilently: 68,
      climbWalls: 89,
      hide: 53,
      listen: 65,
    },
    11: {
      openLocks: 71,
      removeTraps: 66,
      pickPockets: 78,
      moveSilently: 71,
      climbWalls: 90,
      hide: 56,
      listen: 68,
    },
    12: {
      openLocks: 74,
      removeTraps: 69,
      pickPockets: 82,
      moveSilently: 74,
      climbWalls: 91,
      hide: 59,
      listen: 71,
    },
    13: {
      openLocks: 77,
      removeTraps: 72,
      pickPockets: 86,
      moveSilently: 77,
      climbWalls: 92,
      hide: 62,
      listen: 74,
    },
    14: {
      openLocks: 80,
      removeTraps: 75,
      pickPockets: 90,
      moveSilently: 80,
      climbWalls: 93,
      hide: 65,
      listen: 77,
    },
    15: {
      openLocks: 83,
      removeTraps: 78,
      pickPockets: 94,
      moveSilently: 83,
      climbWalls: 94,
      hide: 68,
      listen: 80,
    },
    16: {
      openLocks: 84,
      removeTraps: 79,
      pickPockets: 95,
      moveSilently: 85,
      climbWalls: 95,
      hide: 69,
      listen: 83,
    },
    17: {
      openLocks: 85,
      removeTraps: 80,
      pickPockets: 96,
      moveSilently: 87,
      climbWalls: 96,
      hide: 70,
      listen: 86,
    },
    18: {
      openLocks: 86,
      removeTraps: 81,
      pickPockets: 97,
      moveSilently: 89,
      climbWalls: 97,
      hide: 71,
      listen: 89,
    },
    19: {
      openLocks: 87,
      removeTraps: 82,
      pickPockets: 98,
      moveSilently: 91,
      climbWalls: 98,
      hide: 72,
      listen: 92,
    },
    20: {
      openLocks: 88,
      removeTraps: 83,
      pickPockets: 99,
      moveSilently: 93,
      climbWalls: 99,
      hide: 73,
      listen: 95,
    },
  },
  supplementalContent: false,
};
